import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Check } from "lucide-react";
import Reveal from "../components/Reveal";
import { Icon } from "../lib/icons";
import api from "../lib/api";

export default function Services() {
    const [services, setServices] = useState([]);
    useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

    return (
        <div data-testid="services-page">
            {/* Light header */}
            <section className="bg-cream py-20 lg:py-24 border-b border-[#e8e1d4]">
                <div className="mx-container text-center">
                    <p className="overline mb-5">Services</p>
                    <h1 className="font-display font-semibold tracking-tight text-5xl sm:text-7xl leading-[0.95] max-w-4xl mx-auto">
                        One studio.<br />Every stage of <span className="italic text-brand-gold">your career.</span>
                    </h1>
                    <p className="mt-7 max-w-xl mx-auto text-neutral-500 text-lg">Production, visuals, design, marketing, distribution, education and development, an end-to-end creative partner for independent artists.</p>
                </div>
            </section>

            {/* Compact icon card grid */}
            <section className="py-16 lg:py-24 bg-white">
                <div className="mx-container grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e8e1d4] border border-[#e8e1d4]">
                    {services.map((s, i) => (
                        <Reveal key={s.slug} delay={(i % 3) * 0.05}>
                            <div className="group bg-white p-8 h-full flex flex-col text-center items-center hover:bg-cream transition-colors card-lift" data-testid={`service-card-${s.slug}`}>
                                <div className="flex items-center justify-center gap-4 mb-6">
                                    <span className="h-12 w-12 rounded-full border border-[#e0d6c2] grid place-items-center group-hover:border-brand-gold group-hover:bg-brand-gold/10 transition-colors">
                                        <Icon name={s.icon} className="h-5 w-5 text-brand-golddark" />
                                    </span>
                                    <span className="big-index text-3xl text-[#d8ccb4]">{s.number}</span>
                                </div>
                                <h2 className="font-display font-semibold text-2xl tracking-tight">{s.title}</h2>
                                <p className="mt-1 text-brand-golddark text-xs font-semibold uppercase tracking-[0.16em]">{s.tagline}</p>
                                <p className="mt-4 text-sm text-neutral-500 leading-relaxed flex-1">{s.excerpt}</p>
                                <ul className="mt-5 flex flex-wrap justify-center gap-1.5">
                                    {s.capabilities.slice(0, 4).map((c) => (
                                        <li key={c} className="text-[11px] px-2.5 py-1 bg-cream border border-[#eadfca] text-neutral-600">{c}</li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                    ))}
                    {/* CTA tile */}
                    <div className="bg-espresso text-white p-8 flex flex-col justify-between grain" data-testid="services-cta-tile">
                        <div>
                            <h3 className="font-display font-semibold text-2xl leading-tight">Not sure where <span className="italic text-brand-gold">to start?</span></h3>
                            <p className="mt-3 text-white/60 text-sm">Book a free consultation and we'll map out the right path for you.</p>
                        </div>
                        <Link to="/about" className="mt-6 inline-flex items-center gap-1.5 text-brand-gold uppercase text-sm font-semibold tracking-wide" data-testid="services-cta">
                            Talk to MUVIARTS <ArrowUpRight className="h-4 w-4" />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
